@if (table && rows.length) {
  <div class="analyst-table">
    @if (table.title) {
      <div class="analyst-title">{{ table.title }}</div>
    }
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            @for (column of table.columns; track trackByIndex($index)) {
              <th [class.cell-number]="column.dataType === AnalystColumnType.Number">
                {{ column.label }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track trackByIndex($index)) {
            <tr>
              @for (cell of row.formattedCells; track trackByIndex(cellIndex); let cellIndex = $index; let last = $last) {
                <td
                  [class.cell-number]="table.columns[cellIndex]?.dataType === AnalystColumnType.Number"
                  >
                  {{ cell }}
                  @if (last && row.markers.length) {
                    <sup class="citation-markers">
                      @for (marker of row.visibleMarkers; track trackByIndex($index)) {
                        <a [href]="marker.citation.route" (click)="onMarkerClick($event, marker.citation)">[{{ marker.index }}]</a>
                      }
                    </sup>
                    @if (row.hiddenMarkers.length) {
                      <app-citation-overflow [markers]="row.hiddenMarkers"></app-citation-overflow>
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (table.truncated) {
      <div class="truncation-notice">
        {{ 'Showing {{shown}} of {{total}} rows' | translate: { shown: rows.length, total: table.totalRowCount } }}
      </div>
    }
  </div>
}
